import { render, staticRenderFns } from "./ManuscriptEditorMenuDialog.vue?vue&type=template&id=df865066&scoped=true"
import script from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
export * from "./ManuscriptEditorMenuDialog.vue?vue&type=script&lang=ts"
import style0 from "./ManuscriptEditorMenuDialog.vue?vue&type=style&index=0&id=df865066&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df865066",
  null
  
)

export default component.exports